<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.data.type)">
        <span>{{ organizationTypeString(params.data.type) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: "CellRendererContractType",
    computed: {
        chipColor() {
            return value => {
                if (!value) {
                    return "danger"
                } else if (value === 1) {
                    return "warning"
                } else if (value === 2) {
                    return "success"
                }
            }
        },
        organizationTypeString() {
            return value => {
                if (!value) {
                    return this.$t('employeeTypeOptions.unknown')
                } else if (value === 1) {
                    return this.$t('employeeTypeOptions.trainee')
                } else if (value === 2) {
                    return this.$t('employeeTypeOptions.officialStaff')
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
